module.exports = __webpack_public_path__ + "resources/preloader.e34aafbb485a96ea.gif";


//////////////////
// WEBPACK FOOTER
// ../node_modules/photoswipe/dist/default-skin/preloader.gif
// module id = 646
// module chunks = 0 1 2 3